import { render, staticRenderFns } from "./seoPageTab.vue?vue&type=template&id=6bf99649&scoped=true&lang=pug"
import script from "./seoPageTab.vue?vue&type=script&lang=js"
export * from "./seoPageTab.vue?vue&type=script&lang=js"
import style0 from "./seoPageTab.vue?vue&type=style&index=0&id=6bf99649&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf99649",
  null
  
)

export default component.exports